module.exports = __webpack_public_path__ + "img/github_icon.84952af2.svg";